import { initCountly } from '@/utils/countly';
import { initScout } from '@/utils/scout';
import { apiTest } from '@/utils/apiTest';

initCountly();
initScout(() => {
	apiTest();
});
